import { render, staticRenderFns } from "./WebPartCardRunner.vue?vue&type=template&id=36b309a0&scoped=true&"
import script from "./WebPartCardRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartCardRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartCardRunner.vue?vue&type=style&index=0&id=36b309a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b309a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b309a0')) {
      api.createRecord('36b309a0', component.options)
    } else {
      api.reload('36b309a0', component.options)
    }
    module.hot.accept("./WebPartCardRunner.vue?vue&type=template&id=36b309a0&scoped=true&", function () {
      api.rerender('36b309a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartCardRunner.vue"
export default component.exports